var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFundingSourceActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#347af0;}.a{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(79 228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83 230)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M183.934,181.007a2.93,2.93,0,1,0,2.93,2.93A2.933,2.933,0,0,0,183.934,181.007Zm1.172,3.516h-.586v.586a.586.586,0,1,1-1.172,0v-.586h-.586a.586.586,0,0,1,0-1.172h.586v-.586a.586.586,0,1,1,1.172,0v.586h.586a.586.586,0,0,1,0,1.172Z",
    transform: "translate(-176.317 -173.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M75.652,2.383A11.029,11.029,0,0,1,69.537.493L68.946.1a.584.584,0,0,0-.65,0l-.59.394A11.029,11.029,0,0,1,61.59,2.383.586.586,0,0,0,61,2.969V9.62a10.9,10.9,0,0,0,7.432,10.35.582.582,0,0,0,.371,0A10.9,10.9,0,0,0,76.238,9.62V2.969a.586.586,0,0,0-.586-.586ZM68.621,14.1a4.1,4.1,0,1,1,4.1-4.1A4.106,4.106,0,0,1,68.621,14.1Z",
    transform: "translate(-61.004 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundingSourceActive);
export default __webpack_public_path__ + "static/media/fundingSourceActive.93a7c5dd9e04e9a079f70f0682894ca8.svg";
export { ForwardRef as ReactComponent };